class SaleeCategoriesDrawer extends HTMLElement {
  connectedCallback() {
    this.trigger = this.closest('header-component')?.querySelector('.salee-all-categories');
    this.panels = [...this.querySelectorAll('[data-categories-panel]')];
    this.history = ['root'];

    this.trigger?.addEventListener('click', this.open);
    this.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.open);
    this.removeEventListener('click', this.handleClick);
    document.removeEventListener('keydown', this.handleKeydown);
    window.clearTimeout(this.closeTimer);
    document.body.classList.remove('salee-categories-open');
  }

  open = () => {
    window.clearTimeout(this.closeTimer);
    this.history = ['root'];
    this.showPanel('root', 'open');
    this.classList.remove('is-open');
    this.classList.add('is-visible');
    this.setAttribute('aria-hidden', 'false');
    this.trigger?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('salee-categories-open');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        this.querySelector('[data-categories-close]')?.focus({ preventScroll: true });
      });
    });
  };

  close = () => {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    this.trigger?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('salee-categories-open');
    this.trigger?.focus();
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => this.classList.remove('is-visible'), 580);
  };

  showPanel(id, direction = 'forward') {
    const requestedPanel = this.panels.find((panel) => panel.dataset.categoriesPanel === id);
    if (!requestedPanel) return false;

    this.dataset.direction = direction;
    requestedPanel.classList.remove('is-active');
    void requestedPanel.offsetWidth;
    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.categoriesPanel === id);
      panel.setAttribute('aria-hidden', panel.dataset.categoriesPanel === id ? 'false' : 'true');
    });
    return true;
  }

  handleClick = (event) => {
    const eventElement = event.composedPath().find((node) => node instanceof Element);
    if (!eventElement) return;

    const close = eventElement.closest('[data-categories-close]');
    if (close) return this.close();

    const next = eventElement.closest('[data-categories-next]');
    if (next) {
      event.preventDefault();
      event.stopPropagation();
      const id = next.dataset.categoriesNext;
      this.history.push(id);
      if (!this.showPanel(id, 'forward')) {
        this.history.pop();
        return;
      }
      this.querySelector(`[data-categories-panel="${id}"] [data-categories-back]`)?.focus();
      return;
    }

    if (eventElement.closest('[data-categories-back]') && this.history.length > 1) {
      event.preventDefault();
      this.history.pop();
      const id = this.history.at(-1);
      this.showPanel(id, 'back');
      const panel = this.querySelector(`[data-categories-panel="${id}"]`);
      panel?.querySelector('[data-categories-next], a')?.focus({ preventScroll: true });
    }
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
  };
}

if (!customElements.get('salee-categories-drawer')) {
  customElements.define('salee-categories-drawer', SaleeCategoriesDrawer);
}
